/**
 * TEMPORARY BRIDGE — remove when members-web-app is retired.
 *
 * Auth0's tenant Error Page (firefly-infra `auth0/{dev,staging,prod}.tf` →
 * `error_page.url`) redirects every client's unrecoverable login errors to this
 * app's `/error`. A member who hit a stale-session error mid-login in the React
 * Native web app (`app/`) lands here, on members-web-app, and Auth0 gives this
 * page no way to know which app they came from: for the "couldn't find your
 * session" case it sends `client_id` empty, and the browser exposes no history
 * or referrer signal.
 *
 * So `app/` drops a short-lived marker cookie on the shared `.firefly.health`
 * parent domain right before its Auth0 redirect (see `app/`'s
 * `tokenManager.web.ts`). When that marker is present the login started in
 * `app/`, so send the member back to `app/`'s login. Its URL comes from this
 * app's own `<env>.env`, never the cookie, so the cookie cannot turn the button
 * into an open redirect. With no marker the login started here, so fall back to
 * this app's own login.
 *
 * Spans dev and staging only, where both apps share `firefly.health`. When
 * members-web-app is retired and the tenant Error Page points at `app/`'s own
 * error route, delete this file and the button it feeds in `ErrorScreen`.
 */

// members-web-app's own login entry. Its root re-runs the Landing auth check.
const DEFAULT_LOGIN_URL = '/'

// Marker cookie `app/` web sets before its Auth0 redirect. Short-lived there, so
// a stale marker cannot mis-route a members-web-app login much past the window
// in which the interrupted `app/` login actually happens.
const APP_WEB_ORIGIN_COOKIE = 'firefly_login_origin'
const APP_WEB_ORIGIN_VALUE = 'app-web'

const readCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : null
}

export const resolveLoginUrl = (): string => {
  const cameFromAppWeb = readCookie(APP_WEB_ORIGIN_COOKIE) === APP_WEB_ORIGIN_VALUE
  const appWebUrl = import.meta.env.VITE_APP_WEB_URL
  return cameFromAppWeb && appWebUrl ? appWebUrl : DEFAULT_LOGIN_URL
}
